import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'
import { SendSMSTableUI } from './SendSMSTableUI'

import {SendSMSSearchForm} from './SendSMSSearchForm'
//import { GhorePrizePage } from '../../components/GhorePrizePage'


export class SendSMSTable extends BaseTablePage {

  constructor(props) {
    super(props);
    this.getDataUrl = "api/v1/GetSendSMS?offset=";
    this.className = "SendSMS";
    

    this.state.mode = "table";

    this.state.searchData = {};
  }



  render()
   {
     /*
    if (!this.state.isLoaded) {
      return <div className="box-body"> در حال بارگذاری</div>;
    }
    */


    return (
      <div className="container"> 

        <SendSMSSearchForm onSubmit={this.onSubmitSearchData} onExcelClick={this.onExcelButtonClick} searchData={this.state.searchData} />
        <SendSMSTableUI data={this.state.data}  isReady={this.state.isReady} onViewClick={this.onViewClick} />
        <Pagination pageNumber={this.state.pageNumber} isReady={this.state.isReady} count={this.state.count} perPageCount={this.state.pageSize} onChange={this.handleChangePage} />
        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/tables/sendSMS/SendSMSTable.js